<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keyWord"
        clearable
      ></el-input>
      <!-- <el-select
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择区域"
        v-model="searchData.areaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select> -->
      <el-input-number
        controls-position="right"
        size="small"
        class="mr-10px !w-50 mb-10px"
        :min="1"
        v-model="searchData.inspectionCycle"
        placeholder="请选择排查周期"
        :precision="0"
        clearable
      ></el-input-number>
      <el-select
        v-model="searchData.unitCycle"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查周期单位"
        clearable
      >
        <el-option
          v-for="item in unitCycleList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.inspectionType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查类型"
        clearable
      >
        <el-option
          v-for="item in checkTypeList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.deadlinePersonId"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查人"
        clearable
        filterable
      >
        <el-option
          v-for="item in userList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText">重置</el-button>
    </div>
    <div class="flex-auto h-0px">
      <el-table
        ref="table"
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="作业活动名称"
          width="120"
          prop="jobName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="作业类型" prop="jobActivityType" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ jobTypeMap(scope.row.jobActivityType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="作业活动编号"
          width="120"
          prop="jobNo"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="作业步骤" prop="jobSteps" show-overflow-tooltip></el-table-column>
        <el-table-column label="风险事件" prop="riskEvents" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="排查类容"
          prop="troubleshootContent"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="排查周期" prop="inspectionCycle" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ checkCycleText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排查类型" prop="inspectionType" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ checkTypeMap(scope.row.inspectionType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排查人" prop="deadlinePersonName" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.deadlinePersonName }}
          </template>
        </el-table-column>
        <el-table-column
          label="任务初次生成时间"
          prop="taskStartTime"
          show-overflow-tooltip
          width="180px"
        >
          <template slot-scope="scope">
            {{
              scope.row.taskStartTime
                ? dayjs(scope.row.taskStartTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="任务截止生成时间"
          prop="taskEndTime"
          show-overflow-tooltip
          width="180px"
        >
          <template slot-scope="scope">
            {{
              scope.row.taskEndTime
                ? dayjs(scope.row.taskEndTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }}
          </template>
        </el-table-column>
        <!-- <el-table-column
        label="应排查次数"
        prop="allTroubleshootedCount"
        show-overflow-tooltip
      ></el-table-column> -->
        <el-table-column
          label="已排查次数"
          prop="troubleshootedCount"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
        label="未排查次数"
        prop="notTroubleshootingCount"
        show-overflow-tooltip
      ></el-table-column> -->
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click.native="handleEvent(scope.row, 'read')"
              v-if="$hasAccess('read')"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes ,prev, pager, next"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <RecordsDialog
      type="job"
      :formData="formData"
      @refreshList="findList()"
      v-if="formDialog"
      @cancel="formDialog = false"
    ></RecordsDialog>
  </div>
</template>

<script>
import { TroubleshootingRecordApi } from '@wiz-api/double-prevention-management'
import { AreaApi } from '@wiz-api/area-management'
import { UserApi } from '@wiz-api/abp-identity'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import RecordsDialog from './RecordsDialog'

const userApi = new UserApi()

const areaApi = new AreaApi()

const troubleshootingRecordApi = new TroubleshootingRecordApi()

export default {
  name: 'work-table',
  components: {
    RecordsDialog,
  },
  beforeUpdate() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  data() {
    return {
      unitCycleList: [],
      userList: [],
      formData: {},
      formDialog: false,
      checkTypeList: [],
      jobTypeList: [],
      areaList: [],
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    checkTypeMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    jobTypeMap() {
      return (val) => {
        return (
          this.jobTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkCycleText() {
      return (row) => {
        if (row.inspectionCycle && `${row.unitCycle}`) {
          const unit =
            this.unitCycleList.find((i) => {
              // eslint-disable-next-line eqeqeq
              return i.code == row.unitCycle
            })?.displayName || ''
          return `${row.inspectionCycle}${unit}`
        }
        return ''
      }
    },
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.JobActivityType',
      ],
      ['checkTypeList', 'unitCycleList', 'jobTypeList'],
      this
    )
    this.searchList()
    this.getAreaList()
    this.getUserList()
  },
  methods: {
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      this.selectionData = []
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await troubleshootingRecordApi.queryJobActivity(data)

      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'read':
          this.initDialog(row, operation)
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(row) {
      // 没有新增获取数据
      this.formData = this.$options.data().formData
      this.formData = row
      this.formDialog = true
    },
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.id
      })
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await userApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style></style>
